/**
 * API base URL for Orion AI app (existing api-server).
 * Set REACT_APP_API_URL in .env (e.g. http://localhost:5001 in dev, https://api.ourobi.com in prod).
 * When the page is loaded over HTTPS, the API URL must also be HTTPS (mixed content is blocked).
 *
 * IMPORTANT (orion.ourobi.com): If Orion is served from a different host than the API, you MUST set
 * REACT_APP_API_URL at build time. This module also forces api.ourobi.com when running on known
 * frontend hosts so login never gets 405 even if env was wrong at build time.
 */
const KNOWN_FRONTEND_HOSTS = ['orion.ourobi.com', 'erp.ourobi.com', 'saasadmin.ourobi.com', 'ourobi.com'];

function ensureNotFrontendHost(base) {
  if (typeof window === 'undefined' || !base) return base;
  try {
    const u = new URL(base);
    if (KNOWN_FRONTEND_HOSTS.includes(u.hostname)) {
      return 'https://api.ourobi.com';
    }
  } catch (_) { /* ignore */ }
  return base;
}

const envApiUrl =
  typeof process !== 'undefined' && process.env?.REACT_APP_API_URL;
let base = envApiUrl
  ? String(envApiUrl).replace(/\/+$/, '')
  : (() => {
      if (typeof window !== 'undefined') {
        if (window.location.protocol === 'https:') {
          return window.location.origin;
        }
        const host = window.location.hostname;
        const port = Number(process.env?.REACT_APP_API_PORT) || 5001;
        return `http://${host}:${port}`;
      }
      const port = Number(process.env?.REACT_APP_API_PORT) || 5001;
      return `http://localhost:${port}`;
    })();
base = ensureNotFrontendHost(base);
const API_URL = base;

/** Optional ERP app URL for "Open" links in tool results (e.g. inventory item). Set REACT_APP_ERP_URL. */
export const ERP_URL = typeof process !== 'undefined' && process.env?.REACT_APP_ERP_URL
  ? String(process.env.REACT_APP_ERP_URL).replace(/\/+$/, '')
  : '';

/** AI ask request timeout (ms). Long analyses may need 180000–300000. Set REACT_APP_AI_ASK_TIMEOUT_MS. */
export const AI_ASK_TIMEOUT_MS = Number(process.env?.REACT_APP_AI_ASK_TIMEOUT_MS) || 90000;

export default API_URL;
